import * as React from "react";

// ─── Asset Imports ────────────────────────────────────────────────────────────
// NOTE: Update these import paths to match your project structure

import gdAdDesktop from "../legacy/assets/gd-ad-desktop-JuqFr2jf.jpg";
import tourist360Desktop from "../legacy/assets/tourist-360-desktop-C_oVwXPG.jpg";
import trwBodyDesktop from "../legacy/assets/trw-body-desktop-CrniKfr-.jpg";
import nalamDesktop from "../legacy/assets/nalam-desktop-aIruafaB.jpg";

import gdAdMobile from "../legacy/assets/gd-ad-mobile-Bp6nztJd.jpg";
import tourist360Mobile from "../legacy/assets/tourist-360-mobile-7odF_UPn.jpg";
import trwMobile from "../legacy/assets/trw-mobile-F-sGU8co.jpg";
import nalamMobile from "../legacy/assets/nalam-mobile-FmhftwUX.jpg";

// ─── Named exports matching original (used by AboutUs etc.) ───────────────────
export { trwMobile as a };
export { gdAdMobile as g };
export { nalamMobile as n };
export { tourist360Mobile as t };

// ─── Supported shortcodes ─────────────────────────────────────────────────────

const SUPPORTED_SHORTCODES = new Set(["[trw_ad_slider]", "[trw_ads]", "[trw_gd_brand_creative]"]);

const GD_BRAND_CREATIVE_AD = {
  href: "https://wa.me/919962610113?text=Hi!%20I%20came%20across%20GD%20Brand%20Creative%20on%20Travel%20Rethink%20Ways%20and%20I%27d%20like%20to%20enquire%20about%20your%20creative%20services%20for%20my%20business.",
  image: gdAdDesktop,
  mobileImage: gdAdMobile,
  alt: "GD Brand Creative digital marketing services banner",
  mobileAlt: "GD Brand Creative mobile banner",
  ariaLabel: "Contact GD Brand Creative for creative services",
};

// ─── Ad Banner Data ───────────────────────────────────────────────────────────

const ADS_DESKTOP = [
  {
    href: "https://wa.me/919962610113?text=Hi!%20I%20came%20across%20GD%20Brand%20Creative%20on%20Travel%20Rethink%20Ways%20and%20I%27d%20like%20to%20enquire%20about%20your%20creative%20services%20for%20my%20business.",
    image: gdAdDesktop,
    alt: "GD Brand Creative digital marketing services banner",
    ariaLabel: "Contact GD Brand Creative for creative services",
  },
  {
    href: "https://wa.me/918438506813?text=Hello%21%20We%27d%20love%20to%20know%20more%20about%20The%20Tourist%20360%20Maldives%20Honeymoon%20Package.%20Can%20you%20send%20us%20the%20inclusions%20and%20next%20steps%3F",
    image: tourist360Desktop,
    alt: "Travel RethinkWays brand advertising banner",
    ariaLabel: "Advertise your brand on Travel RethinkWays via WhatsApp",
  },
  {
    href: "https://wa.me/918438506813?text=Hi%21%20I%27m%20interested%20in%20featuring%20our%20brand%20on%20Travel.Rethinkways.%20Could%20you%20share%20more%20details%20about%20ad%20placements%20and%20collaboration%20details%20?",
    image: trwBodyDesktop,
    alt: "Travel RethinkWays ad banner",
    ariaLabel: "Advertise your brand on Travel RethinkWays via WhatsApp",
  },
  {
    href: "https://wa.me/918438506813?text=Hello%21%20We%27d%20love%20to%20know%20more%20about%20Nalam%20Holidays%20Bali%20Honeymoon%20Package.%20Can%20you%20send%20us%20the%20inclusions%20and%20next%20steps%3F",
    image: nalamDesktop,
    alt: "Nalam Holidays Bali Honeymoon package banner",
    ariaLabel: "Bali Honeymoon package",
  },
];

const ADS_TABLET = [
  {
    href: "https://wa.me/919962610113?text=Hi!%20I%20came%20across%20GD%20Brand%20Creative%20on%20Travel%20Rethink%20Ways%20and%20I%27d%20like%20to%20enquire%20about%20your%20creative%20services%20for%20my%20business.",
    image: gdAdDesktop,
    alt: "GD Brand Creative digital marketing services banner",
    ariaLabel: "Contact GD Brand Creative for creative services",
  },
  {
    href: "https://wa.me/918438506813?text=Hello%21%20We%27d%20love%20to%20know%20more%20about%20The%20Tourist%20360%20Maldives%20Honeymoon%20Package.%20Can%20you%20send%20us%20the%20inclusions%20and%20next%20steps%3F",
    image: tourist360Desktop,
    alt: "Travel RethinkWays brand advertising banner",
    ariaLabel: "Advertise your brand on Travel RethinkWays via WhatsApp",
  },
  {
    href: "https://wa.me/918438506813?text=Hi%21%20I%27m%20interested%20in%20featuring%20our%20brand%20on%20Travel.Rethinkways.%20Could%20you%20share%20more%20details%20about%20ad%20placements%20and%20collaboration%20details%20?",
    image: trwBodyDesktop,
    alt: "Travel RethinkWays ad banner",
    ariaLabel: "Advertise your brand on Travel RethinkWays via WhatsApp",
  },
  {
    href: "https://wa.me/918438506813?text=Hello%21%20We%27d%20love%20to%20know%20more%20about%20Nalam%20Holidays%20Bali%20Honeymoon%20Package.%20Can%20you%20send%20us%20the%20inclusions%20and%20next%20steps%3F",
    image: nalamDesktop,
    alt: "Nalam Holidays Bali Honeymoon package banner",
    ariaLabel: "Bali Honeymoon package",
  },
];

const ADS_MOBILE = [
  {
    href: "https://wa.me/919962610113?text=Hi!%20I%20came%20across%20GD%20Brand%20Creative%20on%20Travel%20Rethink%20Ways%20and%20I%27d%20like%20to%20enquire%20about%20your%20creative%20services%20for%20my%20business.",
    image: gdAdMobile,
    alt: "GD Brand Creative mobile banner",
    ariaLabel: "Contact GD Brand Creative for creative services",
  },
  {
    href: "https://wa.me/918438506813?text=Hello%21%20We%27d%20love%20to%20know%20more%20about%20The%20Tourist%20360%20Maldives%20Honeymoon%20Package%20Can%20you%20send%20us%20the%20inclusions%20and%20next%20steps%3F",
    image: tourist360Mobile,
    alt: "Tourist 360 mobile banner",
    ariaLabel: "Tourist 360 Maldives Honeymoon Package",
  },
  {
    href: "https://wa.me/918438506813?text=Hi%21%20I%20saw%20your%20travel%20ads%20on%20mobile.%20Please%20share%20more%20about%20your%20packages%21",
    image: trwMobile,
    alt: "Travel RethinkWays mobile ad banner",
    ariaLabel: "Travel RethinkWays mobile ad",
  },
  {
    href: "https://wa.me/918438506813?text=Hello%21%20We%27d%20love%20to%20know%20more%20about%20Nalam%20Holidays%20Bali%20Honeymoon%20Package.%20Can%20you%20send%20us%20the%20inclusions%20and%20next%20steps%3F",
    image: nalamMobile,
    alt: "Nalam Holidays mobile banner",
    ariaLabel: "Nalam Holidays Bali Honeymoon Package",
  },
];

// ─── Helpers ──────────────────────────────────────────────────────────────────

function getDeviceType() {
  if (typeof window === "undefined") return "desktop";
  if (window.innerWidth >= 1024) return "desktop";
  if (window.innerWidth >= 768) return "tablet";
  return "mobile";
}

// ─── Inline SVG Icon (ChevronRight) ──────────────────────────────────────────

function ChevronRightIcon({ className = "" }) {
  return (
    <svg
      viewBox="0 0 320 512"
      fill="currentColor"
      width="1em"
      height="1em"
      focusable="false"
      className={className}
      aria-hidden="true"
    >
      <path d="M311.1 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L243.2 256 73.9 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
    </svg>
  );
}

// ─── Ad Slider ────────────────────────────────────────────────────────────────

function AdSlider({ className = "" }) {
  const [deviceType, setDeviceType] = React.useState(getDeviceType);
  const [adIndex, setAdIndex] = React.useState(0);

  const ads = React.useMemo(() => {
    if (deviceType === "mobile") return ADS_MOBILE;
    if (deviceType === "tablet") return ADS_TABLET;
    return ADS_DESKTOP;
  }, [deviceType]);

  // Respond to window resize
  React.useEffect(() => {
    const handleResize = () => setDeviceType(getDeviceType());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Auto-rotate banners every 3.5 seconds
  React.useEffect(() => {
    if (ads.length < 2) return;
    const interval = window.setInterval(() => {
      setAdIndex((prev) => (prev + 1) % ads.length);
    }, 3500);
    return () => window.clearInterval(interval);
  }, [ads.length]);

  const currentAd = ads[adIndex % ads.length];
  if (!currentAd) return null;

  return (
    <section
      className={`trw-ad-slider block w-[90%] mx-auto md:w-full text-black [.trw-dark-mode_&]:text-white ${className}`}
    >
      {/* Banner */}
      <div className="flex w-full items-center gap-3">
	        <span
	          className="trw-ad-slider-label text-[7px] tracking-[2px] text-black [writing-mode:vertical-rl] [transform:rotate(180deg)] [font-family:Poppins,sans-serif] [.trw-dark-mode_&]:text-white"
	          aria-hidden="true"
	        >
	          SPONSORED AD
	        </span>
        <div className="min-w-0 flex-1">
          <a
            href={currentAd.href}
            target="_self"
            rel="noopener noreferrer"
            aria-label={currentAd.ariaLabel}
            className="block w-full overflow-hidden rounded-xl"
          >
	            <img
	              src={currentAd.image}
              srcSet={
                currentAd.mobileImage
                  ? `${currentAd.mobileImage} 768w, ${currentAd.image} 1532w`
                  : undefined
              }
	              sizes={currentAd.mobileImage ? "(max-width: 767px) 100vw, 1500px" : undefined}
	              alt={currentAd.alt}
	              width="1500"
	              height="500"
	              className="block h-auto w-full rounded-xl"
	              loading="lazy"
	              decoding="async"
	            />
          </a>
        </div>
      </div>

      {/* Advertise CTA */}
      <div className="mt-2 text-center">
        <a
          href="https://travel.rethinkways.com/advertise-with-us/"
          target="_self"
          rel="noopener noreferrer"
          className="trw-ad-slider-cta inline-flex items-center gap-1 !text-[13px] !leading-[22px] !font-[600] !text-black ![font-family:Poppins,sans-serif] hover:!text-[#D02525] [.trw-dark-mode_&]:!text-white [.trw-dark-mode_&]:hover:!text-[#f87171]"
        >
          Advertise With Us
          <ChevronRightIcon className="text-[13px]" />
        </a>
      </div>
    </section>
  );
}

function SingleAdBanner({ href = "#", image = "", alt = "", ariaLabel = "", className = "" }) {
  if (!image) return null;

  return (
    <section
      className={`trw-ad-slider block w-[90%] mx-auto md:w-full text-black [.trw-dark-mode_&]:text-white ${className}`}
    >
      <div className="flex w-full items-center gap-3">
	        <span
	          className="trw-ad-slider-label text-[7px] tracking-[2px] text-black [writing-mode:vertical-rl] [transform:rotate(180deg)] [font-family:Poppins,sans-serif] [.trw-dark-mode_&]:text-white"
	          aria-hidden="true"
	        >
	          SPONSORED AD
	        </span>
        <div className="min-w-0 flex-1">
          <a
            href={href || "#"}
            target="_self"
            rel="noopener noreferrer"
            aria-label={ariaLabel || alt || "Sponsored ad"}
            className="block w-full overflow-hidden rounded-xl"
          >
	            <img
	              src={image}
	              alt={alt}
	              width="1500"
	              height="500"
	              className="block h-auto w-full rounded-xl"
	              loading="lazy"
	              decoding="async"
	            />
          </a>
        </div>
      </div>

      <div className="mt-2 text-center">
        <a
          href="https://travel.rethinkways.com/advertise-with-us/"
          target="_self"
          rel="noopener noreferrer"
          className="trw-ad-slider-cta inline-flex items-center gap-1 !text-[13px] !leading-[22px] !font-[600] !text-black ![font-family:Poppins,sans-serif] hover:!text-[#D02525] [.trw-dark-mode_&]:!text-white [.trw-dark-mode_&]:hover:!text-[#f87171]"
        >
          Advertise With Us
          <ChevronRightIcon className="text-[13px]" />
        </a>
      </div>
    </section>
  );
}

function ResponsiveSingleAdBanner({
  href = "#",
  image = "",
  mobileImage = "",
  alt = "",
  mobileAlt = "",
  ariaLabel = "",
  className = "",
}) {
  if (!image && !mobileImage) return null;

  const fallbackImage = mobileImage || image;
  const fallbackAlt = mobileAlt || alt;

  return (
    <section
      className={`trw-ad-slider block w-[90%] mx-auto md:w-full text-black [.trw-dark-mode_&]:text-white ${className}`}
    >
      <div className="flex w-full items-center gap-3">
	        <span
	          className="trw-ad-slider-label text-[7px] tracking-[2px] text-black [writing-mode:vertical-rl] [transform:rotate(180deg)] [font-family:Poppins,sans-serif] [.trw-dark-mode_&]:text-white"
	          aria-hidden="true"
	        >
	          SPONSORED AD
	        </span>
        <div className="min-w-0 flex-1">
          <a
            href={href || "#"}
            target="_self"
            rel="noopener noreferrer"
            aria-label={ariaLabel || alt || mobileAlt || "Sponsored ad"}
            className="block w-full overflow-hidden rounded-xl"
          >
            <picture>
              {mobileImage ? <source media="(max-width: 640px)" srcSet={mobileImage} /> : null}
              {image ? <source media="(min-width: 641px)" srcSet={image} /> : null}
	              <img
	                src={fallbackImage}
	                alt={fallbackAlt}
	                width="1500"
	                height="500"
	                className="block h-auto w-full rounded-xl"
	                loading="lazy"
	                decoding="async"
	              />
            </picture>
          </a>
        </div>
      </div>

      <div className="mt-2 text-center">
        <a
          href="https://travel.rethinkways.com/advertise-with-us/"
          target="_self"
          rel="noopener noreferrer"
          className="trw-ad-slider-cta inline-flex items-center gap-1 !text-[13px] !leading-[22px] !font-[600] !text-black ![font-family:Poppins,sans-serif] hover:!text-[#D02525] [.trw-dark-mode_&]:!text-white [.trw-dark-mode_&]:hover:!text-[#f87171]"
        >
          Advertise With Us
          <ChevronRightIcon className="text-[13px]" />
        </a>
      </div>
    </section>
  );
}

// ─── AdShortcode (main export) ────────────────────────────────────────────────

/**
 * Renders an ad slider when the given shortcode is supported,
 * or a single direct banner when href/image props are provided.
 */
export function AdShortcode({ shortcode = "[trw_ad_slider]", className = "", href = "", image = "", alt = "", ariaLabel = "" }) {
  // Ads disabled globally.
  // Keep the component/exports so existing imports don’t break, but render nothing.
  void shortcode;
  void className;
  void href;
  void image;
  void alt;
  void ariaLabel;
  return null;

  if (image) {
    return <SingleAdBanner href={href} image={image} alt={alt} ariaLabel={ariaLabel} className={className} />;
  }
  const normalized = shortcode.trim().toLowerCase();
  if (!SUPPORTED_SHORTCODES.has(normalized)) return null;
  if (normalized === "[trw_gd_brand_creative]") {
    return <ResponsiveSingleAdBanner {...GD_BRAND_CREATIVE_AD} className={className} />;
  }
  return <AdSlider className={className} />;
}

// Named export matching original: export { AdShortcode as A }
export { AdShortcode as A };

export default AdShortcode;

export { ADS_MOBILE };
